import { format } from 'date-fns';

export const instantToUtcIso = (date: Date): string =>
  date.toISOString().replace(/\.\d{3}Z$/, '+00:00');

export const utcInstantToWallClock = (d: Date): Date =>
  new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds()
  );

export const wallClockToUtcIso = (d: Date): string =>
  `${format(d, "yyyy-MM-dd'T'HH:mm:ss")}+00:00`;

// Date string to filter MQL
export const toDateQueryValue = (value: string): { $date: string } | string => {
  const date = new Date(`${value}Z`);
  return Number.isNaN(date.getTime())
    ? value
    : { $date: instantToUtcIso(date) };
};

// Shared format between edit cell and view cell
export const DATE_CELL_FORMAT = 'P p';

// Formatter for view cell
export const formatDateCell = (wallClock: Date, locale: Locale): string =>
  format(wallClock, DATE_CELL_FORMAT, { locale });
